import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import update from 'immutability-helper'
import axios from 'axios';
import MCSItem from "../Components/mcsitem";
import SearchInput from "../Components/searchinput";
import { translate } from '../Services/translation';

export default function MCSContainer() {

    const activeChannelId = useSelector((state) => state.channel.activeChannelId);

    const [originalItems, setOriginalItems] = useState([]);
    const [updated, setUpdated] = useState(false);
    const [mcsItems, setMcsItems] = useState([]);
    const [availableFilters, setAvailableFilters] = useState([]);
    const [availableCategories, setAvailableCategories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [showItpList, setShowItpList] = useState(false);
    const [rootFolderName, setRootFolderName] = useState("");
    const [itp, setItp] = useState(5);
    const [quantity, setQuantity] = useState(0);

    const postValues = (adress, item) => {
        return axios.post(adress, item)
            .then(res => {
                setOriginalItems(res.data.items);
                setMcsItems(res.data.items);
                setAvailableCategories(res.data.availableCategories);
                setQuantity(res.data.quantity);
                setCurrentPage(res.data.currentPage);
            })
    }

    useEffect(() => {
        let itemToSend = {
            channelId: activeChannelId,
            itemsPerPage: itp,
            currentPage: currentPage
        };
        postValues(`/api/mcs/getitems`, itemToSend);
        getRootFolder();
    }, [activeChannelId]);


    const getRootFolder = () => {
        return axios.get(`/api/mcs/getrootfoldername`)
            .then(res => {
                if (res.data != "") {
                    setRootFolderName(res.data);
                }
            })
    }

    const updateItem = (id) => {
        console.log("id", id);
        console.log("mcsItems", mcsItems);
        let itemViewModel = mcsItems.filter(x => x.id == id)[0];
        var paginationViewModel = {
            itemsPerPage: itp,
            currentPage: currentPage
        }
        let channelId = activeChannelId;

        console.log("itemViewModel", itemViewModel);

        let itemToSend = { channelId, itemViewModel, paginationViewModel, id};
        postValues(`/api/mcs/update`, itemToSend);
    };

    const addItem = () => {
        let itemToSend = {
            channelId: activeChannelId,
            itemsPerPage: itp,
            currentPage: 1
        }
        postValues(`/api/mcs/additem`, itemToSend);
    };

    const removeItem = (id) => {
        let itemToSend = {
            channelId: activeChannelId,
            id: id,
            name: itp
        }
        postValues(`/api/mcs/remove`, itemToSend);
    };

    const changeSelectedItp = (itpValue) => {
        setShowItpList(false);
        if (itpValue != itp) {
            setItp(itpValue);
            let itemToSend = {
                channelId: activeChannelId,
                itemsPerPage: itpValue,
                currentPage: 1
            }
            postValues(`/api/mcs/getitems`, itemToSend);
        }
    }

    const getPage = (page) => {
        if (page <= 0) {
            page = 1;
        }
        if (page > Math.ceil(quantity / itp)) {
            page = Math.ceil(quantity / itp);
        }
        let itemToSend = {
            channelId: activeChannelId,
            itemsPerPage: itp,
            currentPage: page
        }
        postValues(`/api/mcs/getitems`, itemToSend);
    }

    const addFilters = (groupId, groupName, filterId, filterName, id) => {
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        let groupFilterIndex = mcsItems[itemIndex].selectedFilters.indexOf(mcsItems[itemIndex].selectedFilters.filter(x => x.groupId == groupId)[0]);
        let newData = null;

        let itemToPush = {
            id: filterId,
            name: filterName
        }

        if (groupFilterIndex != -1) {
            var test = mcsItems[itemIndex].selectedFilters[groupFilterIndex];
            let filterItemIndex = test.filterItemList.indexOf(test.filterItemList.filter(x => x.id == filterId)[0]);
            if (filterItemIndex < 0) {
                if (!mcsItems[itemIndex].editedUrl) {
                    newData = update(mcsItems, { [itemIndex]: { selectedFilters: { [groupFilterIndex]: { filterItemList: { $push: [itemToPush] } } }, editing: { $set: true }, ["url"]: { $set: buildUrlSuggestion(mcsItems[itemIndex].selectedFilters, filterName) } } });
                }
                else {
                    newData = update(mcsItems, { [itemIndex]: { selectedFilters: { [groupFilterIndex]: { filterItemList: { $push: [itemToPush] } } }, editing: { $set: true } } });
                }

                setMcsItems(newData);
            }
        }
        else {
            let groupToPush = {
                groupId: groupId,
                groupName: groupName,
                filterItemList: [itemToPush]
            }
            if (!mcsItems[itemIndex].editedUrl) {
                newData = update(mcsItems, { [itemIndex]: { selectedFilters: { $push: [groupToPush] }, editing: { $set: true }, ["url"]: { $set: buildUrlSuggestion(mcsItems[itemIndex].selectedFilters, filterName) } } });
            }
            else {
                newData = update(mcsItems, { [itemIndex]: { selectedFilters: { $push: [groupToPush] }, editing: { $set: true } } });
            }

            setMcsItems(newData);
        }
    }

    const removeFilters = (groupId, filterId, filterName, id) => {
        let newData = null;
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        let filterGroupIndex = mcsItems[itemIndex].selectedFilters.indexOf(mcsItems[itemIndex].selectedFilters.filter(x => x.groupId == groupId)[0]);
        let filterIndex = mcsItems[itemIndex].selectedFilters[filterGroupIndex].filterItemList.indexOf(mcsItems[itemIndex].selectedFilters[filterGroupIndex].filterItemList.filter(x => x.id == filterId)[0]);
        if (!mcsItems[itemIndex].editedUrl) {
            newData = update(mcsItems, { [itemIndex]: { selectedFilters: { [filterGroupIndex]: { filterItemList: { $splice: [[filterIndex, 1]] } } }, editing: { $set: true }, ["url"]: { $set: buildUrlSuggestion(mcsItems[itemIndex].selectedFilters, filterName, true) } } });
        }
        else {
            newData = update(mcsItems, { [itemIndex]: { selectedFilters: { [filterGroupIndex]: { filterItemList: { $splice: [[filterIndex, 1]] } } }, editing: { $set: true } } });
        }

        setMcsItems(newData);
    }

    const buildUrlSuggestion = (filterList, value, remove = false) => {
        let url = "";
        filterList.map((item) => {
            var i = 0;
            item.filterItemList.map((innerItem) => {
                if (remove) {
                    if (innerItem.name.replace(" ", "-") != value.replace(" ", "-")) {
                        url += innerItem.name.replace(" ", "-") + "/"
                    }
                }
                else {
                    url += innerItem.name.replace(" ", "-") + "/"
                }
            });
        });
        if (!remove) {
            url += value.replace(" ", "-") + "/"
        }
        return url;
    }

    const changeTextField = (id, textField, value) => {
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        if (textField == "url") {
            if (value.trim() == "") {
                let newData = update(mcsItems, {
                    [itemIndex]: { [textField]: { $set: value }, editing: { $set: true }, editedUrl: { $set: false } }
                });
                setMcsItems(newData);
            }
            else {
                if (!mcsItems[itemIndex].editedUrl) {
                    let newData = update(mcsItems, {
                        [itemIndex]: { [textField]: { $set: value }, editing: { $set: true }, editedUrl: { $set: true } }
                    });
                    setMcsItems(newData);
                }
                else {
                    let newData = update(mcsItems, {
                        [itemIndex]: { [textField]: { $set: value }, editing: { $set: true } }
                    });
                    setMcsItems(newData);
                }
            }
        }
        else {
            let newData = update(mcsItems, {
                [itemIndex]: { [textField]: { $set: value }, editing: { $set: true } }
            });
            setMcsItems(newData);
        }
    }

    const changeSelectedCategory = (categoryId, itemId) => {
        let target = availableCategories.filter(x => x.id == categoryId);
        var itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == itemId)[0]);

        let newData = update(mcsItems, {
            [itemIndex]: { selectedCategory: { $set: target[0] }, editing: { $set: true } },
        });

        setUpdated(false);
        setMcsItems(newData);
    }

    const getAvailableFilters = (itemid, cat) => {

        let item = {
            categoryId: cat,
            itemId: itemid,
            channelId: activeChannelId
        }

        axios.post("/api/mcs/getAvailableFiltersForItem", item)
        .then(res => {
            setAvailableFilters(res.data)
        });
    }

    const restoreItem = (id) => {
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        let oldItem = originalItems.filter(x => x.id == id)[0];

        let newData = update(mcsItems, {
            [itemIndex]: { $set: oldItem }
        });

        setMcsItems(newData);
    }

    const saveOrCancel = (save, id) => {
        if (save) {
            updateItem(id);
            setUpdated(true);
        }
        else {
            setUpdated(true);
            restoreItem(id);
        }
    }

    const activateItem = (id, value) => {
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        let newData = update(mcsItems, {
            [itemIndex]: { active: { $set: value } }
        });

        setMcsItems(newData);

        var paginationViewModel = {
            itemsPerPage: itp,
            channelId: activeChannelId,
            currentPage: currentPage
        }
        let itemViewModel = newData.filter(x => x.id == id)[0];
        let itemToSend = { channelId: activeChannelId, itemViewModel, paginationViewModel, id};
        postValues(`/api/mcs/update`, itemToSend);
    }

    const toggleItp = () => {
        setShowItpList(!showItpList);
    }

    const saveButtonValue = (value, id) => {
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        let preparedItem = {
            title: value,
            position: -1,
            volume: -1,
            totalVolume: -1
        }
        let newData = update(mcsItems, {
            [itemIndex]: { searchModel: { searchWords: { $push: [preparedItem] } }, editing: { $set: true } }
        });
        setMcsItems(newData);
    }

    const removeButtonValue = (value, id) => {
        let itemIndex = mcsItems.indexOf(mcsItems.filter(x => x.id == id)[0]);
        let selectedFilters = mcsItems[itemIndex].searchModel.searchWords;
        let filterIndex = selectedFilters.indexOf(selectedFilters.filter(x => x.title == value)[0]);
        let newData = update(mcsItems, {
            [itemIndex]: { searchModel: { searchWords: { $splice: [[filterIndex, 1]] } }, editing: { $set: true } }
        });

        setMcsItems(newData);
    }

    return (
        <>
            <div className="mcs">
                <div className="mcs__top-row row">
                    <div className="top-container col-2">
                        <div className="mcs__add" onClick={() => addItem()}><i className="fas fa-plus-circle"></i><h2>{translate("mcs.add")}</h2></div>
                    </div>
                    <div className="top-container col-8">
                        <SearchInput {...{ postValues, itp }} />
                    </div>
                    <div className="top-container col-2">
                        <div className="mcs__itp-wrapper">
                            <div className="mcs__itp-container">
                                <div className="mcs__itp-controller" onClick={() => toggleItp("itp")}>
                                    <span>{itp}</span>
                                    <i className={showItpList ? "fas fa-chevron-down rotate-180" : "fas fa-chevron-down"}></i>
                                </div>
                                <div className={showItpList ? "mcs__itp-list mcs__itp-list--show" : "mcs__itp-list"}>
                                    <span className="mcs__itp-object" onClick={() => changeSelectedItp(5)}>5</span>
                                    <span className="mcs__itp-object" onClick={() => changeSelectedItp(10)}>10</span>
                                    <span className="mcs__itp-object" onClick={() => changeSelectedItp(50)}>50</span>
                                    <span className="mcs__itp-object" onClick={() => changeSelectedItp(100)}>100</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mcs__item-container row">
                    {mcsItems && mcsItems.map((item, index, array) => (
                        <MCSItem key={index}
                            {
                            ...{
                                ...item,
                                availableFilters: availableFilters,
                                availableCategories: availableCategories,
                                addFilters,
                                updated,
                                editing: item.editing,
                                saveOrCancel,
                                changeSelectedCategory,
                                changeTextField,
                                removeFilters,
                                removeItem,
                                activateItem,
                                saveButtonValue,
                                removeButtonValue,
                                rootFolderName,
                                getAvailableFilters
                            }
                            }
                        />
                    ))}
                </div>
                <div className="mcs__bottom-row row">
                    {quantity != 0 &&
                        <>
                            <div className="mcs__pagination-container"></div>
                            <div className="mcs__pagination-container">
                                <i className="fas fa-chevron-left" onClick={() => getPage(currentPage - 1)}></i><span>{currentPage} {translate("mcs.of")} {Math.ceil(quantity / itp)}</span><i className="fas fa-chevron-right" onClick={() => getPage(currentPage + 1)}></i>
                            </div>
                            <div className="mcs__total-container">
                                <span>{translate("mcs.totalrules")} : {quantity}</span>
                            </div>
                        </>
                     }
                </div>
            </div>
        </>
    );
}

